import React, { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { withTenant } from "@/lib/tenant";

export const TenantLogo = ({ className, testId }) => {
  const { brand } = useAuth();
  const [failed, setFailed] = useState(false);
  const src = withTenant("/api/assets/logo-email.png");
  useEffect(() => setFailed(false), [src]);
  if (failed) return <span className="font-heading text-lg font-medium tracking-tight text-slate-900 leading-tight" data-testid={testId}>{brand?.name || "Portal"}</span>;
  return <img src={src} alt={brand?.portal_name || "Portal"} className={className} data-testid={testId} onError={() => setFailed(true)} />;
};
